module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Gd-Db-Ec.265f5427.png";